/**
 * Toggle Cart popup
 *
 * @return {void}
 */

const activeClass = 'is-active';
const cartPopupBtnClass = '.js-cart-toggle-trigger';
const cartPopupClass = '.js-cart-popup';

/**
 * Expand cart popup
 */

$(document).on('click', `${cartPopupBtnClass}`, function(e) {
  e.preventDefault();

  $(cartPopupClass).toggleClass(activeClass);
});
